export type OutcomeTableColumn = {
    key: string;
    label: string;
    format?: (value: unknown) => string;
};

export type OutcomeTableRow = Record<string, unknown>;

export type OutcomeTableConfig = {
    title: string;
    columns: OutcomeTableColumn[];
    getRows: (outcomes: Record<string, unknown>) => OutcomeTableRow[];
    match?: (outcomes: Record<string, unknown>) => boolean;
};

export const getRecord = (value: unknown): Record<string, unknown> => {
    if (value && typeof value === 'object' && !Array.isArray(value)) {
        return value as Record<string, unknown>;
    }

    return {};
};

export const getScale = (scales: Record<string, unknown>, key: string) => getRecord(scales[key]);

export const getScales = (outcomes: Record<string, unknown>) => getRecord(outcomes?.scales);

export const getNumber = (value: unknown) => (typeof value === 'number' ? value : null);

export const getString = (value: unknown) => (typeof value === 'string' ? value : null);

export const getBoolean = (value: unknown) => (typeof value === 'boolean' ? value : null);

export const formatOutOf = (value: unknown, max: number) => {
    const numericValue = getNumber(value);
    return numericValue === null ? null : `${numericValue} de ${max}`;
};

export const mapClinicalLabel = (clinical: unknown) => {
    const normalizedClinical = getBoolean(clinical);

    if (normalizedClinical === null) return null;

    return normalizedClinical ? 'Clínico' : 'Não Clínico';
};

export const mapRiskLabel = (positive: unknown) => {
    const normalizedPositive = getBoolean(positive);

    if (normalizedPositive === null) return null;

    return normalizedPositive ? 'Presente (avaliar risco clinicamente)' : 'Ausente';
};

export const mapScreeningLabel = (positive: unknown) => {
    const normalizedPositive = getBoolean(positive);

    if (normalizedPositive === null) return null;

    return normalizedPositive
        ? 'Positivo para rastreio (avaliar clinicamente)'
        : 'Negativo para rastreio';
};

export const mapBingeLabel = (present: unknown) => {
    const normalizedPresent = getBoolean(present);

    if (normalizedPresent === null) return null;

    return normalizedPresent ? 'Presente' : 'Ausente';
};

export const formatYesNo = (value: unknown) => {
    const normalizedValue = getBoolean(value);

    if (normalizedValue === null) return null;

    return normalizedValue ? 'Sim' : 'Não';
};

export const domainColumns: OutcomeTableColumn[] = [
    { key: 'domain', label: 'Domínio' },
    { key: 'result', label: 'Resultado' },
    { key: 'interpretation', label: 'Interpretação' },
];
